import { ChevronRight } from '@mui/icons-material';
import { AppDivider } from 'components/core/AppDivider/AppDivider';
import Grid from 'components/core/Grid';
import { LoadingButton } from 'components/core/LoadingButton/LoadingButton';
import { FormikAppEmail } from 'components/formik/core/FormikAppEmail/FormikAppEmail';
import { FormikAppTextField } from 'components/formik/core/FormikAppTextField/FormikAppTextField';
import { ResetPasswordFormikValues } from 'components/views/pages/forgot-password/initialValues';
import { useFormikContext } from 'formik';

export const ResetPasswordForm = () => {
  const { isSubmitting } = useFormikContext<ResetPasswordFormikValues>();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <AppDivider />
      </Grid>
      <Grid item xs={12}>
        <FormikAppEmail name="email" disabled={true} />
      </Grid>
      <Grid item xs={12}>
        <FormikAppTextField name="PASSWORD" isPasswordField label="New Password" />
      </Grid>
      <Grid item xs={12}>
        <FormikAppTextField name="PASSWORD_CONFIRM" isPasswordField label="Confirm New Password" />
      </Grid>
      <Grid item xs={12}>
        <LoadingButton isLoading={isSubmitting} text="Reset Password" isFullWidth isFormikButton endIcon={<ChevronRight />} />
      </Grid>
    </Grid>
  );
};
